var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlanItemRow1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BADGE_GARANTIA",
    "data-name": "BADGE GARANTIA",
    transform: "translate(-1008 -224)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20",
    "data-name": "Ellipse 20",
    cx: 29,
    cy: 29,
    r: 29,
    transform: "translate(1011 227)",
    fill: "#858a96",
    opacity: 0.241
  }), /*#__PURE__*/React.createElement("g", {
    id: "Badge",
    transform: "translate(1017.402 242.805)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2292",
    "data-name": "Path 2292",
    d: "M1,35.141l3.481-5.571L1,24H44.172l-3.481,5.571,3.481,5.571Z",
    transform: "translate(-0.303 -16.341)",
    fill: "#858a96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2293",
    "data-name": "Path 2293",
    d: "M22.839,39.068a2.47,2.47,0,0,1-.632-.082,2.533,2.533,0,0,1-1.59-1.274L19.9,36.354A2.517,2.517,0,0,0,17.723,35a2.51,2.51,0,0,1-1.863-.885,2.592,2.592,0,0,1-.587-2.049l.082-.569a2.579,2.579,0,0,0-.628-2.094l-1.021-1.144a2.585,2.585,0,0,1,0-3.445l1.021-1.144a2.583,2.583,0,0,0,.628-2.093l-.083-.569a2.593,2.593,0,0,1,.589-2.049,2.507,2.507,0,0,1,1.863-.884A2.516,2.516,0,0,0,19.9,16.716l.713-1.358a2.534,2.534,0,0,1,1.59-1.274,2.453,2.453,0,0,1,.63-.082,2.491,2.491,0,0,1,1.351.4l.708.456a2.5,2.5,0,0,0,2.7,0L28.3,14.4a2.5,2.5,0,0,1,1.982-.315,2.535,2.535,0,0,1,1.59,1.274l.713,1.358a2.517,2.517,0,0,0,2.181,1.356,2.51,2.51,0,0,1,1.863.885,2.592,2.592,0,0,1,.587,2.049l-.082.569a2.58,2.58,0,0,0,.628,2.094l1.021,1.144a2.585,2.585,0,0,1,0,3.445L37.764,29.4a2.583,2.583,0,0,0-.628,2.093l.083.569a2.593,2.593,0,0,1-.589,2.049A2.507,2.507,0,0,1,34.767,35a2.516,2.516,0,0,0-2.181,1.357l-.713,1.358a2.534,2.534,0,0,1-1.59,1.275,2.5,2.5,0,0,1-1.982-.315l-.708-.456a2.5,2.5,0,0,0-2.7,0l-.708.456A2.491,2.491,0,0,1,22.839,39.068Z",
    transform: "translate(-3.962 -13.306)",
    fill: "#fef2ef"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 7.66,
    cy: 7.66,
    r: 7.66,
    transform: "translate(14.623 5.57)",
    fill: "#858a96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2294",
    "data-name": "Path 2294",
    d: "M28.23,30.888l-2.013-1.962,2.783-.4L30.244,26l1.244,2.521,2.783.4-2.013,1.962.475,2.771-2.489-1.308L27.755,33.66Z",
    transform: "translate(-7.961 -16.949)",
    fill: "#fef2ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2295",
    "data-name": "Path 2295",
    d: "M39,24.045,37.979,22.9a1.885,1.885,0,0,1-.458-1.531L37.6,20.8a3.29,3.29,0,0,0-.747-2.6,3.206,3.206,0,0,0-2.381-1.13,1.82,1.82,0,0,1-1.576-.984l-.713-1.358a3.233,3.233,0,0,0-2.029-1.625,3.2,3.2,0,0,0-2.536.4l-.708.456a1.8,1.8,0,0,1-1.942,0l-.708-.456a3.189,3.189,0,0,0-2.536-.4A3.233,3.233,0,0,0,19.7,14.73l-.713,1.358a1.82,1.82,0,0,1-1.577.984,3.206,3.206,0,0,0-2.381,1.13,3.29,3.29,0,0,0-.747,2.6l.082.569A1.887,1.887,0,0,1,13.9,22.9l-1.021,1.144a3.281,3.281,0,0,0,0,4.372L13.9,29.561a1.885,1.885,0,0,1,.458,1.531l-.082.568a3.29,3.29,0,0,0,.747,2.6,3.206,3.206,0,0,0,2.381,1.13,1.82,1.82,0,0,1,1.576.984l.713,1.358a3.233,3.233,0,0,0,2.029,1.625,3.191,3.191,0,0,0,2.536-.4l.708-.456a1.8,1.8,0,0,1,1.942,0l.708.456a3.192,3.192,0,0,0,2.536.4,3.233,3.233,0,0,0,2.029-1.624l.713-1.358a1.821,1.821,0,0,1,1.577-.984,3.206,3.206,0,0,0,2.381-1.13,3.29,3.29,0,0,0,.747-2.6l-.082-.57a1.887,1.887,0,0,1,.458-1.53L39,28.417A3.281,3.281,0,0,0,39,24.045ZM37.961,27.49,36.94,28.633a3.279,3.279,0,0,0-.8,2.656l.082.569a1.892,1.892,0,0,1-.429,1.5,1.784,1.784,0,0,1-1.344.64,3.214,3.214,0,0,0-2.787,1.729l-.713,1.358a1.81,1.81,0,0,1-1.151.925,1.773,1.773,0,0,1-1.427-.227l-.708-.456a3.192,3.192,0,0,0-3.449,0l-.708.456a1.777,1.777,0,0,1-1.427.227,1.81,1.81,0,0,1-1.151-.925l-.712-1.358A3.214,3.214,0,0,0,17.431,34a1.784,1.784,0,0,1-1.344-.64,1.893,1.893,0,0,1-.429-1.5l.081-.568a3.277,3.277,0,0,0-.8-2.657l-1.021-1.144a1.889,1.889,0,0,1,0-2.517l1.021-1.144a3.278,3.278,0,0,0,.8-2.656l-.082-.569a1.892,1.892,0,0,1,.429-1.5,1.784,1.784,0,0,1,1.344-.64,3.214,3.214,0,0,0,2.787-1.729l.713-1.358a1.81,1.81,0,0,1,1.151-.924,1.775,1.775,0,0,1,1.427.227l.708.456a3.192,3.192,0,0,0,3.449,0l.708-.456a1.77,1.77,0,0,1,1.427-.227,1.81,1.81,0,0,1,1.151.925l.713,1.358a3.214,3.214,0,0,0,2.786,1.729,1.784,1.784,0,0,1,1.344.64,1.893,1.893,0,0,1,.429,1.5l-.081.568a3.276,3.276,0,0,0,.8,2.657l1.021,1.144A1.889,1.889,0,0,1,37.961,27.49Z",
    transform: "translate(-3.658 -13.002)",
    fill: "#404757"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2296",
    "data-name": "Path 2296",
    d: "M28.356,20a8.356,8.356,0,1,0,8.356,8.356A8.356,8.356,0,0,0,28.356,20Zm0,15.319a6.963,6.963,0,1,1,6.963-6.963,6.963,6.963,0,0,1-6.963,6.963Z",
    transform: "translate(-6.073 -15.127)",
    fill: "#404757"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2297",
    "data-name": "Path 2297",
    d: "M34.067,27.947l-2.42-.352L30.564,25.4a.725.725,0,0,0-1.249,0L28.233,27.6l-2.42.352a.7.7,0,0,0-.386,1.188l1.752,1.707-.414,2.411a.7.7,0,0,0,1.01.734l2.166-1.138,2.165,1.138a.7.7,0,0,0,1.01-.734L32.7,30.842l1.752-1.707a.7.7,0,0,0-.386-1.188Zm-2.6,2.153a.7.7,0,0,0-.2.616L31.5,32.1l-1.24-.652a.7.7,0,0,0-.648,0l-1.24.652.237-1.381a.7.7,0,0,0-.2-.616l-1-.978,1.386-.2a.7.7,0,0,0,.524-.381l.62-1.256.62,1.256a.7.7,0,0,0,.524.381l1.386.2Z",
    transform: "translate(-7.657 -16.659)",
    fill: "#404757"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2298",
    "data-name": "Path 2298",
    d: "M56.629,29.267l3.25-5.2A.7.7,0,0,0,59.289,23H51.476a.7.7,0,1,0,0,1.393h6.556L55.217,28.9a.7.7,0,0,0,0,.738l2.815,4.505H51.476a.7.7,0,1,0,0,1.393h7.813a.7.7,0,0,0,.59-1.065Z",
    transform: "translate(-15.42 -16.038)",
    fill: "#404757"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2299",
    "data-name": "Path 2299",
    d: "M8.509,34.141H1.953l2.815-4.505a.7.7,0,0,0,0-.738L1.953,24.393H8.509a.7.7,0,1,0,0-1.393H.7a.7.7,0,0,0-.59,1.065l3.25,5.2-3.25,5.2A.7.7,0,0,0,.7,35.534H8.509a.7.7,0,1,0,0-1.393Z",
    transform: "translate(0 -16.038)",
    fill: "#404757"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_21",
    "data-name": "Ellipse 21",
    transform: "translate(1008 224)",
    fill: "none",
    stroke: "#404757",
    strokeWidth: 2,
    opacity: 0.787
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 31,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanItemRow1);
export default __webpack_public_path__ + "static/media/plan-item-row1.78715486b541827971db1399e88069ec.svg";
export { ForwardRef as ReactComponent };